// Function to initialize event listeners and handle form data
function initPopupEventHandlers() {
  const fileName = 'form-demo-popup';
  const popup = document.getElementById(`popup-${fileName}`);

  if (!popup) {
    console.error(`Popup not found for ${fileName}`);
    return;
  }

  const formDataElement = document.getElementById(`form-data-${fileName}`);

  if (!formDataElement) {
    console.error(`Form data not found for ${fileName}`);
    return;
  }

  const formData = JSON.parse(formDataElement.textContent);
  const form = document.getElementById(formData.formId);
  const closePopup = document.querySelector(formData.closeButtonSelector);
  let lastTrigger = null;

  function syncDisclosureSelects() {
    if (!form) return;
    form.querySelectorAll('form-disclosure-select').forEach((el) => {
      if (typeof el.syncFromSelect === 'function') el.syncFromSelect();
    });
  }

  function preFillForm(form, button) {
    const ownerZip = button.getAttribute('data-zip');
    const ownerCity = button.getAttribute('data-city');
    const ownerState = button.getAttribute('data-state');
    const ownerVehicle = button.getAttribute('data-vehicle');
    const ownerFirstName = button.getAttribute('data-first-name');
    const ownerLastName = button.getAttribute('data-last-name');
    const ownerEmail = button.getAttribute('data-email');

    const zipElement = document.getElementById('selected-zip');
    const selectedZip = zipElement ? zipElement.getAttribute('data-selected-zip') : null;
    const vehicleModelSelector = document.querySelector('vehicle-model-selector');
    let selectedVehicle = null;

    if (vehicleModelSelector) {
      const vehicleSpan = vehicleModelSelector.querySelector('#vehicle-model-value, .disclosure__button span');
      selectedVehicle = vehicleSpan ? vehicleSpan.getAttribute('data-selected-vehicle') || vehicleSpan.textContent.trim() : null;
      const placeholder = vehicleSpan ? vehicleSpan.getAttribute('data-label') : '';
      if (selectedVehicle && placeholder && selectedVehicle === placeholder) selectedVehicle = null;
    }

    const zipInput = form.querySelector('#zip-code');
    const truckModelInput = form.querySelector('#truck-model');
    const emailInput = form.querySelector('#owner-email');
    const firstNameInput = form.querySelector('#owner-first-name');
    const lastNameInput = form.querySelector('#owner-last-name');

    if (zipInput) zipInput.value = selectedZip || ownerZip || '';
    if (truckModelInput) {
      truckModelInput.value = selectedVehicle || ownerVehicle || '';
      truckModelInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (emailInput) emailInput.value = ownerEmail || '';
    if (firstNameInput) firstNameInput.value = ownerFirstName || '';
    if (lastNameInput) lastNameInput.value = ownerLastName || '';

    syncDisclosureSelects();
    initializeGeocoder(selectedZip || ownerZip);
  }

  function openPopup(button) {
    lastTrigger = button;
    popup.removeEventListener('transitionend', onPopupCloseEnd);
    popup.classList.remove('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    if (form) preFillForm(form, button);
    requestAnimationFrame(() => {
      popup.classList.add('show');
      const focusTarget = closePopup || popup.querySelector('h3, h2, .disclosure__button, input, button');
      if (typeof trapFocus === 'function') trapFocus(popup, focusTarget);
      else if (focusTarget) focusTarget.focus();
    });
  }

  function onPopupCloseEnd(event) {
    if (event.target !== popup || event.propertyName !== 'opacity') return;
    popup.classList.add('hidden');
    popup.removeEventListener('transitionend', onPopupCloseEnd);
  }

  function closePopupModal() {
    if (popup.classList.contains('hidden') && !popup.classList.contains('show')) return;
    popup.classList.remove('show');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(lastTrigger);
    else if (lastTrigger) lastTrigger.focus();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      popup.classList.add('hidden');
      return;
    }
    popup.addEventListener('transitionend', onPopupCloseEnd);
  }

  if (popup.dataset.a11yReady === 'true') return;
  popup.dataset.a11yReady = 'true';

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[show-demo-popup]');
    if (!button) return;
    openPopup(button);
  });

  if (closePopup) {
    closePopup.addEventListener('click', closePopupModal);
  }

  popup.addEventListener('click', function (event) {
    if (event.target === popup) closePopupModal();
  });

  popup.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const openDisclosure = popup.querySelector('form-disclosure-select.is-open');
    if (openDisclosure) return;
    closePopupModal();
  });

  popup.closePopupModal = closePopupModal;
}

async function initializeGeocoder(zip) {
  const { Geocoder } = await google.maps.importLibrary('geocoding');

  const cityInput = document.getElementById('city');
  const stateProvinceInput = document.getElementById('state');

  if (!cityInput || !stateProvinceInput) {
    console.error('City or State input not found');
    return;
  }

  const geocoder = new Geocoder();

  if (!zip) {
    cityInput.value = '';
    stateProvinceInput.value = '';
    return;
  }

  cityInput.value = 'Looking up City...';
  stateProvinceInput.value = 'Looking up State / Province...';

  try {
    const response = await geocoder.geocode({ address: zip });

    if (response.results && response.results[0]) {
      const result = response.results[0];
      const addressComponents = result.address_components;
      const city = addressComponents.find((component) => component.types.includes('locality'))?.long_name || '';
      const state =
        addressComponents.find((component) => component.types.includes('administrative_area_level_1'))?.short_name ||
        '';

      cityInput.value = city;
      stateProvinceInput.value = state;
    } else {
      cityInput.value = '';
      stateProvinceInput.value = '';
    }
  } catch (error) {
    console.error('Geocoding failed:', error);
    cityInput.value = '';
    stateProvinceInput.value = '';
  }
}

function gm_authFailure() {
  console.error('Google Maps authentication failed. Please check your API key and restrictions.');
}

document.addEventListener('customersLoaded', function () {
  initPopupEventHandlers();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPopupEventHandlers);
} else {
  initPopupEventHandlers();
}
